export default __webpack_public_path__ + "static/media/img12.05804a23.jpg";